// removed by extract-text-webpack-plugin
module.exports = {"focus":"ButtonAnimated__focus___2kV4X","button":"ButtonAnimated__button___RUEpk","disabled":"ButtonAnimated__disabled___3wK2t","default":"ButtonAnimated__default___1Fikt","loading":"ButtonAnimated__loading___1kndO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonAnimated/ButtonAnimated.css
// module id = 697
// module chunks = 0